<template>
  <Tabs v-model="activeTabName" :width="160" :height="60">
    <TabPane v-for="item in tabPages" :cnLabel="item.cnText" :enLabel="item.enText" :name="item.name">
      <component :is=item.component></component>
    </TabPane>
  </Tabs>
</template>
<script>
import {TabPane, Tabs} from "@/components/TabPage";
import ToBeAssign from "@/views/mediator/ToBeAssign";
import PendingAppointment from "@/views/mediator/PendingAppointment";
import PendingMediation from "@/views/mediator/PendingMediation";
import Mediated from "@/views/mediator/Mediated";

export default {
  components: {
    Tabs,
    TabPane,
    ToBeAssign,
    PendingAppointment,
    PendingMediation,
    Mediated,
  },
  created() {
    let mediationTabName = this.$store.state.app.mediationTabName;
    if (mediationTabName !== '' && mediationTabName !== undefined) {
      this.activeTabName = mediationTabName;
    }
  },
  data() {
    return {
      // 默认展示Tab
      activeTabName: "ToBeAssign",
      tabPages: [
        {
          cnText: '待分配',
          enText: 'To Be Assigned',
          name: 'ToBeAssign',
          component: 'ToBeAssign',
        },
        {
          cnText: '待预约',
          enText: 'Pending Appointment',
          name: 'PendingAppointment',
          component: 'PendingAppointment'
        },
        {
          cnText: '待调解',
          enText: 'Pending Mediation',
          name: 'PendingMediation',
          component: 'PendingMediation'
        },
        {
          cnText: '已调解',
          enText: 'Mediated',
          name: 'Mediated',
          component: 'Mediated'
        }
      ]
    };
  },
};
</script>
<style lang="less">
</style>
